<template>
  <div>
    <c-tab
      v-if="tabItems.length > 0"
      type="horizon"
      :inlineLabel="true"
      :dense="true"
      :height="tabHeight"
      :tabItems="tabItems"
      v-model="currentLawTab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :lawCode="tab.name"
          :lawName="tab.label"
          :regulationItems="tab.items"
          :contentHeight="tabHeight"
          @refresh="refreshData"
        />
      </template>
    </c-tab>

    <div v-else class="flex flex-center" :style="{ height: tabHeight }">
      <q-spinner-dots color="primary" size="40px" />
    </div>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";

// 상세 컴포넌트 비동기 로드 정의
const DetailComponent = () => import("./chemUpdateDetail.vue");

export default {
  name: "chemUpdate",
  components: {
    // 컴포넌트를 명시적으로 등록해야 'is'에서 문자열로 호출 가능합니다.
    DetailComponent,
  },
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopCtoId: "",
      }),
    },
  },
  data() {
    return {
      currentLawTab: "",
      windowHeight: window.innerHeight,
      listUrl: "",
      tabItems: [],
      editable: true,
      iconMap: {
        D100: "science",
        D110: "biotech",
        D120: "health_and_safety",
        D130: "propane",
        D140: "local_fire_department",
        D150: "air",
        D160: "water_drop",
        D170: "landscape",
        D180: "masks",
        D200: "recycling",
        D210: "eco",
      },
      defaultIcon: "description",
      highlightTabs: ["D100", "D120", "D140"],
    };
  },
  computed: {
    tabHeight() {
      return this.windowHeight - 120 + "px";
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.regulation.item.list.url;
      this.getRegulationList();
    },
    handleResize() {
      this.windowHeight = window.innerHeight;
    },
    getRegulationList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = { useFlag: "Y" };
      this.$http.request((_result) => {
        const data = _result.data || [];
        this.makeTabs(data);
      });
    },
    makeTabs(data) {
      const grouped = data.reduce((acc, item) => {
        const key = item.regulationBillCd;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      const newTabs = Object.keys(grouped).map((billCd) => {
        const items = grouped[billCd];
        const firstItem = items[0];
        const label =
          firstItem.regulationBillName || firstItem.regulationBillNm || billCd;
        const icon = this.iconMap[billCd] || this.defaultIcon;

        return {
          name: billCd,
          label: label,
          icon: icon,
          // 컴포넌트 객체가 아닌 등록된 '문자열 이름'을 전달
          component: "DetailComponent",
          items: items,
          style: this.highlightTabs.includes(billCd)
            ? { color: "#e53935" }
            : {},
        };
      });

      newTabs.sort((a, b) => a.name.localeCompare(b.name));
      this.tabItems = newTabs;

      if (newTabs.length > 0 && !this.currentLawTab) {
        this.currentLawTab = newTabs[0].name;
      }
    },
    refreshData() {
      this.getRegulationList();
    },
  },
};
</script>
